import { render } from "./SizeComponent.vue?vue&type=template&id=87b0aad8&scoped=true"
import script from "./SizeComponent.vue?vue&type=script&lang=js"
export * from "./SizeComponent.vue?vue&type=script&lang=js"

import "./SizeComponent.vue?vue&type=style&index=0&id=87b0aad8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87b0aad8"]])

export default __exports__